<template>
  <div class="CartPayment md:flex justify-between -mx-4 space-y-4 md:space-y-0" v-if="cartId">
    <Paypal :cartId="cartId" />
    <Stripe v-show="showStripe" @show="showStripe = true" />
  </div>
</template>

<script>
import Stripe from "./Stripe.vue"
import Paypal from "./Paypal.vue"

export default {
  name: "Cart.Payment",
  data: () => ({
    showStripe: false,
  }),
  props: {
    cartId: {
      type: String,
      required: true,
    },
  },
  components: {
    Paypal,
    Stripe,
  },
}
</script>
